export default __webpack_public_path__ + "static/media/544.b7fb3c3a.gif";